import React, { PureComponent } from 'react';
import styled from 'styled-components';

const StyledModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;

  .Modal__backdrop {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    background: rgba(0,0,0,0.3);
    width: 100%;
    height: 100%;
    padding: 25px;
  }

  .Modal__modal {
    img {
      width: 100%;
      max-width: 1200px;
      height: auto;
    }
  }
`;

class ImageSlider extends PureComponent {
  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown = e => {
    if (e.keyCode === 27) this.props.onClose();
  };

  render() {
    const { image, description, onClose } = this.props;

    return (
      <StyledModal>
        <div className="Modal__backdrop" onClick={onClose}>
          <div className="Modal__modal" onClick={e => e.stopPropagation()}>
            <img src={image} alt={description} />
          </div>
        </div>
      </StyledModal>
    );
  }
}

export default ImageSlider;



// WEBPACK FOOTER //
// ./src/components/ImageModal.js